import { render, staticRenderFns } from "./generalLevel.vue?vue&type=template&id=1241a3fc&"
import script from "./generalLevel.vue?vue&type=script&lang=js&"
export * from "./generalLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports